window.__VUE_DEVTOOLS_TOAST__ = (message: string, type?: string) => {
    if (type === 'error') {
        console.error(message);
    } else if (type === 'warn') {
        console.warn(message);
    }
};

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

declare global {
    interface Window {
        Echo: any
        Pusher: any
    }
}

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { http } from '@inertiajs/vue3'

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
    wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
    wsPort: import.meta.env.VITE_PUSHER_PORT ?? 6002,
    wssPort: import.meta.env.VITE_PUSHER_PORT ?? 6002,
    forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
})

/**
 * Echo puts the socket id only on axios requests, and Inertia visits no longer go through axios:
 * without it, broadcast()->toOthers() sends a change back to the tab that made it.
 */
http.onRequest((config) => {
    const socketId = window.Echo.socketId()
    if (socketId) {
        config.headers['X-Socket-Id'] = socketId
    }
    return config
})
